import { render, staticRenderFns } from "./AsideLinks.vue?vue&type=template&id=74536a80&scoped=true&"
import script from "./AsideLinks.vue?vue&type=script&lang=js&"
export * from "./AsideLinks.vue?vue&type=script&lang=js&"
import style0 from "./AsideLinks.vue?vue&type=style&index=0&id=74536a80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74536a80",
  null
  
)

export default component.exports